import { useState, useEffect } from 'react'
import api from '../../services/api'
import toast from 'react-hot-toast'

export default function Plantillas() {
  const [items, setItems] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [editando, setEditando] = useState(null)
  const [form, setForm] = useState({ nombre: '', categoria: '', contenido: '' })

  const cargar = async () => { const { data } = await api.get('/respuestas/plantillas'); setItems(data) }
  useEffect(() => { cargar() }, [])

  const guardar = async (e) => {
    e.preventDefault()
    try {
      if (editando) await api.put(`/respuestas/plantillas/${editando.id}`, form)
      else await api.post('/respuestas/plantillas', form)
      toast.success('Guardado')
      setShowModal(false); setEditando(null); setForm({ nombre: '', categoria: '', contenido: '' })
      cargar()
    } catch (e) { toast.error(e.response?.data?.error || 'Error') }
  }

  const eliminar = async (id) => {
    if (!window.confirm('¿Eliminar?')) return
    await api.delete(`/respuestas/plantillas/${id}`); cargar()
  }

  const editar = (item) => { setEditando(item); setForm({ nombre: item.nombre, categoria: item.categoria || '', contenido: item.contenido }); setShowModal(true) }

  return (
    <div className="page">
      <div className="flex justify-between items-center" style={{ marginBottom: 18 }}>
        <div>
          <h1 className="text-2xl font-bold">📋 Plantillas de mensajes</h1>
          <p className="text-muted">Mensajes reutilizables con variables {`{{nombre}}`}</p>
        </div>
        <button className="btn btn-primary" onClick={() => { setEditando(null); setForm({ nombre: '', categoria: '', contenido: '' }); setShowModal(true) }}>+ Nueva</button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 14 }}>
        {items.map(item => (
          <div key={item.id} className="card">
            <div className="flex justify-between" style={{ marginBottom: 8 }}>
              <div className="font-semibold">{item.nombre}</div>
              {item.categoria && <span className="badge">{item.categoria}</span>}
            </div>
            <div className="text-sm text-soft" style={{ whiteSpace: 'pre-wrap', marginBottom: 12, minHeight: 60, maxHeight: 100, overflow: 'hidden' }}>{item.contenido}</div>
            {item.variables?.length > 0 && (
              <div style={{ marginBottom: 12 }}>
                {item.variables.map(v => <span key={v} className="badge badge-info" style={{ marginRight: 4 }}>{`{{${v}}}`}</span>)}
              </div>
            )}
            <div className="flex gap-2">
              <button className="btn btn-sm btn-outline" onClick={() => editar(item)}>✏️ Editar</button>
              <button className="btn btn-sm btn-danger" onClick={() => eliminar(item.id)}>🗑️</button>
            </div>
          </div>
        ))}
      </div>

      {items.length === 0 && <div className="empty-state"><div className="empty-state-icon">📋</div>Sin plantillas</div>}

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <span className="modal-title">{editando ? 'Editar' : 'Nueva'} plantilla</span>
              <button className="btn btn-ghost btn-icon" onClick={() => setShowModal(false)}>✕</button>
            </div>
            <form onSubmit={guardar}>
              <div className="modal-body">
                <div className="form-group"><label className="form-label">Nombre</label><input className="input" required value={form.nombre} onChange={e => setForm({...form, nombre: e.target.value})} /></div>
                <div className="form-group"><label className="form-label">Categoría</label><input className="input" value={form.categoria} onChange={e => setForm({...form, categoria: e.target.value})} placeholder="bienvenida, seguimiento, cobranza..." /></div>
                <div className="form-group"><label className="form-label">Contenido</label><textarea className="textarea" rows={6} required value={form.contenido} onChange={e => setForm({...form, contenido: e.target.value})} placeholder="Hola {{nombre}}, te escribo para..." /></div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn" onClick={() => setShowModal(false)}>Cancelar</button>
                <button className="btn btn-primary">Guardar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  )
}
